/* tslint:disable-next-line:max-line-length */
import { intl } from "../i18n/TypedIntl";
import { lazy } from "../utils/lazy";

export interface Country {
  iso: string;
  name: string;
  search: string;
  weight: number;
  code: number;
}

export class CountryService {
  countries: Array<Country> = [
    { iso: "AD", name: intl.formatMessage("country.ad"), search: "AD", weight: 0.5, code: 376 },
    {
      iso: "AE",
      name: intl.formatMessage("country.ae"),
      search: "AE UAE الإمارات",
      weight: 1,
      code: 971
    },
    {
      iso: "AF",
      name: intl.formatMessage("country.af"),
      search: "AF افغانستان",
      weight: 1,
      code: 93
    },
    { iso: "AG", name: intl.formatMessage("country.ag"), search: "AG", weight: 0.5, code: 1268 },
    { iso: "AI", name: intl.formatMessage("country.ai"), search: "AI", weight: 0.5, code: 1264 },
    { iso: "AL", name: intl.formatMessage("country.al"), search: "AL", weight: 1, code: 355 },
    {
      iso: "AM",
      name: intl.formatMessage("country.am"),
      search: "AM Հայաստան",
      weight: 1,
      code: 374
    },
    { iso: "AO", name: intl.formatMessage("country.ao"), search: "AO", weight: 1, code: 244 },
    { iso: "AQ", name: intl.formatMessage("country.aq"), search: "AQ", weight: 0.5, code: 672 },
    { iso: "AR", name: intl.formatMessage("country.ar"), search: "AR", weight: 1, code: 54 },
    { iso: "AS", name: intl.formatMessage("country.as"), search: "AS", weight: 0.5, code: 1684 },
    {
      iso: "AT",
      name: intl.formatMessage("country.at"),
      search: "AT Österreich Osterreich Oesterreich ",
      weight: 1,
      code: 43
    },
    { iso: "AU", name: intl.formatMessage("country.au"), search: "AU", weight: 1.5, code: 61 },
    { iso: "AW", name: intl.formatMessage("country.aw"), search: "AW", weight: 0.5, code: 297 },
    {
      iso: "AX",
      name: intl.formatMessage("country.ax"),
      search: "AX Aaland Aland",
      weight: 0.5,
      code: 358
    },
    { iso: "AZ", name: intl.formatMessage("country.az"), search: "AZ", weight: 1, code: 994 },
    {
      iso: "BA",
      name: intl.formatMessage("country.ba"),
      search: "BA BiH Bosna i Hercegovina Босна и Херцеговина",
      weight: 1,
      code: 387
    },
    { iso: "BB", name: intl.formatMessage("country.bb"), search: "BB", weight: 1, code: 1246 },
    {
      iso: "BD",
      name: intl.formatMessage("country.bd"),
      search: "BD বাংলাদেশ",
      weight: 2,
      code: 880
    },
    {
      iso: "BE",
      name: intl.formatMessage("country.be"),
      search: "BE België Belgie Belgien Belgique",
      weight: 1.5,
      code: 32
    },
    { iso: "BF", name: intl.formatMessage("country.bf"), search: "BF", weight: 1, code: 226 },
    {
      iso: "BG",
      name: intl.formatMessage("country.bg"),
      search: "BG България",
      weight: 1,
      code: 359
    },
    {
      iso: "BH",
      name: intl.formatMessage("country.bh"),
      search: "BH البحرين",
      weight: 1,
      code: 973
    },
    { iso: "BI", name: intl.formatMessage("country.bi"), search: "BI", weight: 1, code: 257 },
    { iso: "BJ", name: intl.formatMessage("country.bj"), search: "BJ", weight: 1, code: 229 },
    {
      iso: "BL",
      name: intl.formatMessage("country.bl"),
      search: "BL St. Barthelemy",
      weight: 1,
      code: 590
    },
    { iso: "BM", name: intl.formatMessage("country.bm"), search: "BM", weight: 0.5, code: 1441 },
    { iso: "BN", name: intl.formatMessage("country.bn"), search: "BN", weight: 1, code: 673 },
    { iso: "BO", name: intl.formatMessage("country.bo"), search: "BO", weight: 1, code: 591 },
    { iso: "BQ", name: intl.formatMessage("country.bq"), search: "BQ", weight: 1, code: 599 },
    { iso: "BR", name: intl.formatMessage("country.br"), search: "BR Brasil", weight: 2, code: 55 },
    { iso: "BS", name: intl.formatMessage("country.bs"), search: "BS", weight: 1, code: 1242 },
    { iso: "BT", name: intl.formatMessage("country.bt"), search: "BT भूटान", weight: 1, code: 975 },
    { iso: "BV", name: intl.formatMessage("country.bv"), search: "BV", weight: 1, code: 47 },
    { iso: "BW", name: intl.formatMessage("country.bw"), search: "BW", weight: 1, code: 267 },
    {
      iso: "BY",
      name: intl.formatMessage("country.by"),
      search: "BY Беларусь",
      weight: 1,
      code: 375
    },
    { iso: "BZ", name: intl.formatMessage("country.bz"), search: "BZ", weight: 1, code: 501 },
    { iso: "CA", name: intl.formatMessage("country.ca"), search: "CA", weight: 2, code: 1 },
    { iso: "CC", name: intl.formatMessage("country.cc"), search: "CC", weight: 0.5, code: 672 },
    {
      iso: "CD",
      name: intl.formatMessage("country.cd"),
      search: "CD Congo-Brazzaville Repubilika ya Kongo",
      weight: 1,
      code: 243
    },
    { iso: "CF", name: intl.formatMessage("country.cf"), search: "CF", weight: 1, code: 236 },
    { iso: "CG", name: intl.formatMessage("country.cg"), search: "CG", weight: 1, code: 242 },
    {
      iso: "CH",
      name: intl.formatMessage("country.ch"),
      search: "CH Swiss Confederation Schweiz Suisse Svizzera Svizra",
      weight: 1.5,
      code: 41
    },
    {
      iso: "CI",
      name: intl.formatMessage("country.ci"),
      search: "CI Cote dIvoire",
      weight: 1,
      code: 225
    },
    { iso: "CK", name: intl.formatMessage("country.ck"), search: "CK", weight: 0.5, code: 682 },
    { iso: "CL", name: intl.formatMessage("country.cl"), search: "CL", weight: 1, code: 56 },
    { iso: "CM", name: intl.formatMessage("country.cm"), search: "CM", weight: 1, code: 237 },
    {
      iso: "CN",
      name: intl.formatMessage("country.cn"),
      search: "CN Zhongguo Zhonghua Peoples Republic 中国/中华",
      weight: 3.5,
      code: 86
    },
    { iso: "CO", name: intl.formatMessage("country.co"), search: "CO", weight: 1, code: 57 },
    { iso: "CR", name: intl.formatMessage("country.cr"), search: "CR", weight: 1, code: 506 },
    { iso: "CU", name: intl.formatMessage("country.cu"), search: "CU", weight: 1, code: 53 },
    { iso: "CV", name: intl.formatMessage("country.cv"), search: "CV Cabo", weight: 1, code: 238 },
    {
      iso: "CW",
      name: intl.formatMessage("country.cw"),
      search: "CW Curacao",
      weight: 1,
      code: 599
    },
    { iso: "CX", name: intl.formatMessage("country.cx"), search: "CX", weight: 0.5, code: 672 },
    {
      iso: "CY",
      name: intl.formatMessage("country.cy"),
      search: "CY Κύπρος Kýpros Kıbrıs",
      weight: 1,
      code: 357
    },
    {
      iso: "CZ",
      name: intl.formatMessage("country.cz"),
      search: "CZ Česká Ceska",
      weight: 1,
      code: 420
    },
    {
      iso: "DE",
      name: intl.formatMessage("country.de"),
      search: "DE Bundesrepublik Deutschland",
      weight: 3,
      code: 49
    },
    {
      iso: "DJ",
      name: intl.formatMessage("country.dj"),
      search: "DJ جيبوتي‎ Jabuuti Gabuuti",
      weight: 1,
      code: 253
    },
    {
      iso: "DK",
      name: intl.formatMessage("country.dk"),
      search: "DK Danmark",
      weight: 1.5,
      code: 45
    },
    {
      iso: "DM",
      name: intl.formatMessage("country.dm"),
      search: "DM Dominique",
      weight: 0.5,
      code: 1767
    },
    { iso: "DO", name: intl.formatMessage("country.do"), search: "DO", weight: 1, code: 1809 },
    {
      iso: "DZ",
      name: intl.formatMessage("country.dz"),
      search: "DZ الجزائر",
      weight: 1,
      code: 213
    },
    { iso: "EC", name: intl.formatMessage("country.ec"), search: "EC", weight: 1, code: 593 },
    { iso: "EE", name: intl.formatMessage("country.ee"), search: "EE Eesti", weight: 1, code: 372 },
    { iso: "EG", name: intl.formatMessage("country.eg"), search: "EG", weight: 1.5, code: 20 },
    {
      iso: "EH",
      name: intl.formatMessage("country.eh"),
      search: "EH لصحراء الغربية",
      weight: 1,
      code: 212
    },
    {
      iso: "ER",
      name: intl.formatMessage("country.er"),
      search: "ER إرتريا ኤርትራ",
      weight: 1,
      code: 291
    },
    { iso: "ES", name: intl.formatMessage("country.es"), search: "ES España", weight: 2, code: 34 },
    { iso: "ET", name: intl.formatMessage("country.et"), search: "ET ኢትዮጵያ", weight: 1, code: 251 },
    { iso: "FI", name: intl.formatMessage("country.fi"), search: "FI Suomi", weight: 1, code: 358 },
    {
      iso: "FJ",
      name: intl.formatMessage("country.fj"),
      search: "FJ Viti फ़िजी",
      weight: 1,
      code: 679
    },
    { iso: "FK", name: intl.formatMessage("country.fk"), search: "FK", weight: 0.5, code: 500 },
    { iso: "FM", name: intl.formatMessage("country.fm"), search: "FM", weight: 1, code: 691 },
    {
      iso: "FO",
      name: intl.formatMessage("country.fo"),
      search: "FO Føroyar Færøerne",
      weight: 0.5,
      code: 298
    },
    {
      iso: "FR",
      name: intl.formatMessage("country.fr"),
      search: "FR République française",
      weight: 2.5,
      code: 33
    },
    {
      iso: "GA",
      name: intl.formatMessage("country.ga"),
      search: "GA République Gabonaise",
      weight: 1,
      code: 241
    },
    {
      iso: "GB",
      name: intl.formatMessage("country.gb"),
      search: "GB Great Britain England UK Wales Scotland Northern Ireland",
      weight: 2.5,
      code: 44
    },
    { iso: "GD", name: intl.formatMessage("country.gd"), search: "GD", weight: 1, code: 1473 },
    {
      iso: "GE",
      name: intl.formatMessage("country.ge"),
      search: "GE საქართველო",
      weight: 1,
      code: 995
    },
    { iso: "GF", name: intl.formatMessage("country.gf"), search: "GF", weight: 1, code: 594 },
    { iso: "GG", name: intl.formatMessage("country.gg"), search: "GG", weight: 0.5, code: 44 },
    { iso: "GH", name: intl.formatMessage("country.gh"), search: "GH", weight: 1, code: 233 },
    { iso: "GI", name: intl.formatMessage("country.gi"), search: "GI", weight: 0.5, code: 350 },
    {
      iso: "GL",
      name: intl.formatMessage("country.gl"),
      search: "GL grønland",
      weight: 0.5,
      code: 299
    },
    { iso: "GM", name: intl.formatMessage("country.gm"), search: "GM", weight: 1, code: 220 },
    { iso: "GN", name: intl.formatMessage("country.gn"), search: "GN", weight: 1, code: 224 },
    { iso: "GP", name: intl.formatMessage("country.gp"), search: "GP", weight: 1, code: 590 },
    { iso: "GQ", name: intl.formatMessage("country.gq"), search: "GQ", weight: 1, code: 240 },
    {
      iso: "GR",
      name: intl.formatMessage("country.gr"),
      search: "GR Ελλάδα",
      weight: 1.5,
      code: 30
    },
    { iso: "GS", name: intl.formatMessage("country.gs"), search: "GS", weight: 1, code: 500 },
    { iso: "GT", name: intl.formatMessage("country.gt"), search: "GT", weight: 1, code: 502 },
    { iso: "GU", name: intl.formatMessage("country.gu"), search: "GU", weight: 1, code: 1671 },
    { iso: "GW", name: intl.formatMessage("country.gw"), search: "GW", weight: 1, code: 245 },
    { iso: "GY", name: intl.formatMessage("country.gy"), search: "GY", weight: 1, code: 592 },
    { iso: "HK", name: intl.formatMessage("country.hk"), search: "HK 香港", weight: 1, code: 852 },
    { iso: "HM", name: intl.formatMessage("country.hm"), search: "HM", weight: 1, code: 672 },
    { iso: "HN", name: intl.formatMessage("country.hn"), search: "HN", weight: 1, code: 504 },
    {
      iso: "HR",
      name: intl.formatMessage("country.hr"),
      search: "HR Hrvatska",
      weight: 1,
      code: 385
    },
    { iso: "HT", name: intl.formatMessage("country.ht"), search: "HT", weight: 1, code: 509 },
    {
      iso: "HU",
      name: intl.formatMessage("country.hu"),
      search: "HU Magyarország",
      weight: 1,
      code: 36
    },
    { iso: "ID", name: intl.formatMessage("country.id"), search: "ID", weight: 2, code: 62 },
    {
      iso: "IE",
      name: intl.formatMessage("country.ie"),
      search: "IE Éire",
      weight: 1.2,
      code: 353
    },
    {
      iso: "IL",
      name: intl.formatMessage("country.il"),
      search: "IL إسرائيل ישראל",
      weight: 1,
      code: 972
    },
    { iso: "IM", name: intl.formatMessage("country.im"), search: "IM", weight: 0.5, code: 44 },
    {
      iso: "IN",
      name: intl.formatMessage("country.in"),
      search: "IN भारत गणराज्य Hindustan",
      weight: 3,
      code: 91
    },
    { iso: "IO", name: intl.formatMessage("country.io"), search: "IO", weight: 1, code: 246 },
    {
      iso: "IQ",
      name: intl.formatMessage("country.iq"),
      search: "IQ العراق‎",
      weight: 1,
      code: 964
    },
    { iso: "IR", name: intl.formatMessage("country.ir"), search: "IR ایران", weight: 1, code: 98 },
    {
      iso: "IS",
      name: intl.formatMessage("country.is"),
      search: "IS Island",
      weight: 1,
      code: 354
    },
    { iso: "IT", name: intl.formatMessage("country.it"), search: "IT Italia", weight: 2, code: 39 },
    { iso: "JE", name: intl.formatMessage("country.je"), search: "JE", weight: 0.5, code: 44 },
    { iso: "JM", name: intl.formatMessage("country.jm"), search: "JM", weight: 1, code: 1876 },
    {
      iso: "JO",
      name: intl.formatMessage("country.jo"),
      search: "JO الأردن",
      weight: 1,
      code: 962
    },
    {
      iso: "JP",
      name: intl.formatMessage("country.jp"),
      search: "JP Nippon Nihon 日本",
      weight: 2.5,
      code: 81
    },
    { iso: "KE", name: intl.formatMessage("country.ke"), search: "KE", weight: 1, code: 254 },
    {
      iso: "KG",
      name: intl.formatMessage("country.kg"),
      search: "KG Кыргызстан",
      weight: 1,
      code: 996
    },
    {
      iso: "KH",
      name: intl.formatMessage("country.kh"),
      search: "KH កម្ពុជា",
      weight: 1,
      code: 855
    },
    { iso: "KI", name: intl.formatMessage("country.ki"), search: "KI", weight: 1, code: 686 },
    {
      iso: "KM",
      name: intl.formatMessage("country.km"),
      search: "KM جزر القمر",
      weight: 1,
      code: 269
    },
    { iso: "KN", name: intl.formatMessage("country.kn"), search: "KN St.", weight: 1, code: 1869 },
    {
      iso: "KP",
      name: intl.formatMessage("country.kp"),
      search: "KP North Korea",
      weight: 1,
      code: 850
    },
    {
      iso: "KR",
      name: intl.formatMessage("country.kr"),
      search: "KR South Korea",
      weight: 1.5,
      code: 82
    },
    {
      iso: "KW",
      name: intl.formatMessage("country.kw"),
      search: "KW الكويت",
      weight: 1,
      code: 965
    },
    { iso: "KY", name: intl.formatMessage("country.ky"), search: "KY", weight: 0.5, code: 1345 },
    {
      iso: "KZ",
      name: intl.formatMessage("country.kz"),
      search: "KZ Қазақстан Казахстан",
      weight: 1,
      code: 7
    },
    { iso: "LA", name: intl.formatMessage("country.la"), search: "LA", weight: 1, code: 856 },
    { iso: "LB", name: intl.formatMessage("country.lb"), search: "LB لبنان", weight: 1, code: 961 },
    { iso: "LC", name: intl.formatMessage("country.lc"), search: "LC St.", weight: 1, code: 1758 },
    { iso: "LI", name: intl.formatMessage("country.li"), search: "LI", weight: 1, code: 423 },
    {
      iso: "LK",
      name: intl.formatMessage("country.lk"),
      search: "LK ශ්‍රී ලංකා இலங்கை Ceylon",
      weight: 1,
      code: 94
    },
    { iso: "LR", name: intl.formatMessage("country.lr"), search: "LR", weight: 1, code: 231 },
    { iso: "LS", name: intl.formatMessage("country.ls"), search: "LS", weight: 1, code: 266 },
    {
      iso: "LT",
      name: intl.formatMessage("country.lt"),
      search: "LT Lietuva",
      weight: 1,
      code: 370
    },
    { iso: "LU", name: intl.formatMessage("country.lu"), search: "LU", weight: 1, code: 352 },
    {
      iso: "LV",
      name: intl.formatMessage("country.lv"),
      search: "LV Latvija",
      weight: 1,
      code: 371
    },
    { iso: "LY", name: intl.formatMessage("country.ly"), search: "LY ليبيا", weight: 1, code: 218 },
    {
      iso: "MA",
      name: intl.formatMessage("country.ma"),
      search: "MA المغرب",
      weight: 1,
      code: 212
    },
    { iso: "MC", name: intl.formatMessage("country.mc"), search: "MC", weight: 1, code: 377 },
    { iso: "MD", name: intl.formatMessage("country.md"), search: "MD", weight: 1, code: 373 },
    { iso: "ME", name: intl.formatMessage("country.me"), search: "ME", weight: 1, code: 382 },
    { iso: "MF", name: intl.formatMessage("country.mf"), search: "MF St.", weight: 1, code: 590 },
    {
      iso: "MG",
      name: intl.formatMessage("country.mg"),
      search: "MG Madagasikara",
      weight: 1,
      code: 261
    },
    { iso: "MH", name: intl.formatMessage("country.mh"), search: "MH", weight: 0.5, code: 692 },
    {
      iso: "MK",
      name: intl.formatMessage("country.mk"),
      search: "MK Македонија",
      weight: 1,
      code: 389
    },
    { iso: "ML", name: intl.formatMessage("country.ml"), search: "ML", weight: 1, code: 223 },
    { iso: "MM", name: intl.formatMessage("country.mm"), search: "MM", weight: 1, code: 95 },
    {
      iso: "MN",
      name: intl.formatMessage("country.mn"),
      search: "MN Mongγol ulus Монгол улс",
      weight: 1,
      code: 976
    },
    { iso: "MO", name: intl.formatMessage("country.mo"), search: "MO", weight: 1, code: 853 },
    { iso: "MP", name: intl.formatMessage("country.mp"), search: "MP", weight: 0.5, code: 1670 },
    { iso: "MQ", name: intl.formatMessage("country.mq"), search: "MQ", weight: 1, code: 596 },
    {
      iso: "MR",
      name: intl.formatMessage("country.mr"),
      search: "MR الموريتانية",
      weight: 1,
      code: 222
    },
    { iso: "MS", name: intl.formatMessage("country.ms"), search: "MS", weight: 0.5, code: 1664 },
    { iso: "MT", name: intl.formatMessage("country.mt"), search: "MT", weight: 1, code: 356 },
    { iso: "MU", name: intl.formatMessage("country.mu"), search: "MU", weight: 1, code: 230 },
    { iso: "MV", name: intl.formatMessage("country.mv"), search: "MV", weight: 1, code: 960 },
    { iso: "MW", name: intl.formatMessage("country.mw"), search: "MW", weight: 1, code: 265 },
    {
      iso: "MX",
      name: intl.formatMessage("country.mx"),
      search: "MX Mexicanos",
      weight: 1.5,
      code: 52
    },
    { iso: "MY", name: intl.formatMessage("country.my"), search: "MY", weight: 1, code: 60 },
    {
      iso: "MZ",
      name: intl.formatMessage("country.mz"),
      search: "MZ Moçambique",
      weight: 1,
      code: 258
    },
    {
      iso: "NA",
      name: intl.formatMessage("country.na"),
      search: "NA Namibië",
      weight: 1,
      code: 264
    },
    { iso: "NC", name: intl.formatMessage("country.nc"), search: "NC", weight: 0.5, code: 687 },
    { iso: "NE", name: intl.formatMessage("country.ne"), search: "NE Nijar", weight: 1, code: 227 },
    { iso: "NF", name: intl.formatMessage("country.nf"), search: "NF", weight: 0.5, code: 672 },
    {
      iso: "NG",
      name: intl.formatMessage("country.ng"),
      search: "NG Nijeriya Naíjíríà",
      weight: 1.5,
      code: 234
    },
    { iso: "NI", name: intl.formatMessage("country.ni"), search: "NI", weight: 1, code: 505 },
    {
      iso: "NL",
      name: intl.formatMessage("country.nl"),
      search: "NL Holland Nederland",
      weight: 1.5,
      code: 31
    },
    {
      iso: "NO",
      name: intl.formatMessage("country.no"),
      search: "NO Norge Noreg",
      weight: 1.5,
      code: 47
    },
    { iso: "NP", name: intl.formatMessage("country.np"), search: "NP नेपाल", weight: 1, code: 977 },
    {
      iso: "NR",
      name: intl.formatMessage("country.nr"),
      search: "NR Naoero",
      weight: 0.5,
      code: 674
    },
    { iso: "NU", name: intl.formatMessage("country.nu"), search: "NU", weight: 0.5, code: 683 },
    {
      iso: "NZ",
      name: intl.formatMessage("country.nz"),
      search: "NZ Aotearoa",
      weight: 1,
      code: 64
    },
    { iso: "OM", name: intl.formatMessage("country.om"), search: "OM عمان", weight: 1, code: 968 },
    { iso: "PA", name: intl.formatMessage("country.pa"), search: "PA", weight: 1, code: 507 },
    { iso: "PE", name: intl.formatMessage("country.pe"), search: "PE", weight: 1, code: 51 },
    {
      iso: "PF",
      name: intl.formatMessage("country.pf"),
      search: "PF Polynésie française",
      weight: 1,
      code: 689
    },
    { iso: "PG", name: intl.formatMessage("country.pg"), search: "PG", weight: 1, code: 675 },
    {
      iso: "PH",
      name: intl.formatMessage("country.ph"),
      search: "PH Pilipinas",
      weight: 1.5,
      code: 63
    },
    {
      iso: "PK",
      name: intl.formatMessage("country.pk"),
      search: "PK پاکستان",
      weight: 2,
      code: 92
    },
    {
      iso: "PL",
      name: intl.formatMessage("country.pl"),
      search: "PL Polska",
      weight: 1.25,
      code: 48
    },
    { iso: "PM", name: intl.formatMessage("country.pm"), search: "PM St.", weight: 1, code: 508 },
    { iso: "PN", name: intl.formatMessage("country.pn"), search: "PN", weight: 0.5, code: 672 },
    { iso: "PR", name: intl.formatMessage("country.pr"), search: "PR", weight: 1, code: 1 },
    {
      iso: "PS",
      name: intl.formatMessage("country.ps"),
      search: "PS فلسطين",
      weight: 1,
      code: 970
    },
    {
      iso: "PT",
      name: intl.formatMessage("country.pt"),
      search: "PT Portuguesa",
      weight: 1.5,
      code: 351
    },
    { iso: "PW", name: intl.formatMessage("country.pw"), search: "PW", weight: 0.5, code: 680 },
    { iso: "PY", name: intl.formatMessage("country.py"), search: "PY", weight: 1, code: 595 },
    { iso: "QA", name: intl.formatMessage("country.qa"), search: "QA قطر", weight: 1, code: 974 },
    {
      iso: "RE",
      name: intl.formatMessage("country.re"),
      search: "RE Reunion",
      weight: 1,
      code: 262
    },
    {
      iso: "RO",
      name: intl.formatMessage("country.ro"),
      search: "RO Rumania Roumania România",
      weight: 1,
      code: 40
    },
    {
      iso: "RS",
      name: intl.formatMessage("country.rs"),
      search: "RS Србија Srbija",
      weight: 1,
      code: 381
    },
    {
      iso: "RU",
      name: intl.formatMessage("country.ru"),
      search: "RU Rossiya Российская Россия",
      weight: 2.5,
      code: 7
    },
    { iso: "RW", name: intl.formatMessage("country.rw"), search: "RW", weight: 1, code: 250 },
    {
      iso: "SA",
      name: intl.formatMessage("country.sa"),
      search: "SA السعودية",
      weight: 1,
      code: 966
    },
    { iso: "SB", name: intl.formatMessage("country.sb"), search: "SB", weight: 1, code: 677 },
    { iso: "SC", name: intl.formatMessage("country.sc"), search: "SC", weight: 0.5, code: 248 },
    {
      iso: "SD",
      name: intl.formatMessage("country.sd"),
      search: "SD السودان",
      weight: 1,
      code: 249
    },
    {
      iso: "SE",
      name: intl.formatMessage("country.se"),
      search: "SE Sverige",
      weight: 1.5,
      code: 46
    },
    {
      iso: "SG",
      name: intl.formatMessage("country.sg"),
      search: "SG Singapura  சிங்கப்பூர் குடியரசு 新加坡共和国",
      weight: 1,
      code: 65
    },
    { iso: "SH", name: intl.formatMessage("country.sh"), search: "SH St.", weight: 1, code: 290 },
    {
      iso: "SI",
      name: intl.formatMessage("country.si"),
      search: "SI Slovenija",
      weight: 1,
      code: 386
    },
    { iso: "SJ", name: intl.formatMessage("country.sj"), search: "SJ", weight: 0.5, code: 47 },
    {
      iso: "SK",
      name: intl.formatMessage("country.sk"),
      search: "SK Slovenská Slovensko",
      weight: 1,
      code: 421
    },
    { iso: "SL", name: intl.formatMessage("country.sl"), search: "SL", weight: 1, code: 232 },
    {
      iso: "SM",
      name: intl.formatMessage("country.sm"),
      search: "SM RSM Repubblica",
      weight: 1,
      code: 378
    },
    {
      iso: "SN",
      name: intl.formatMessage("country.sn"),
      search: "SN Sénégal",
      weight: 1,
      code: 221
    },
    {
      iso: "SO",
      name: intl.formatMessage("country.so"),
      search: "SO الصومال",
      weight: 1,
      code: 252
    },
    {
      iso: "SR",
      name: intl.formatMessage("country.sr"),
      search: "SR शर्नम् Sarnam Sranangron",
      weight: 1,
      code: 597
    },
    { iso: "SS", name: intl.formatMessage("country.ss"), search: "SS", weight: 1, code: 211 },
    { iso: "ST", name: intl.formatMessage("country.st"), search: "ST", weight: 1, code: 239 },
    { iso: "SV", name: intl.formatMessage("country.sv"), search: "SV", weight: 1, code: 503 },
    { iso: "SX", name: intl.formatMessage("country.sx"), search: "SX", weight: 1, code: 599 },
    {
      iso: "SY",
      name: intl.formatMessage("country.sy"),
      search: "SY Syria سورية",
      weight: 1,
      code: 963
    },
    {
      iso: "SZ",
      name: intl.formatMessage("country.sz"),
      search: "SZ weSwatini Swatini Ngwane",
      weight: 1,
      code: 268
    },
    { iso: "TC", name: intl.formatMessage("country.tc"), search: "TC", weight: 0.5, code: 1649 },
    {
      iso: "TD",
      name: intl.formatMessage("country.td"),
      search: "TD تشاد‎ Tchad",
      weight: 1,
      code: 235
    },
    { iso: "TF", name: intl.formatMessage("country.tf"), search: "TF", weight: 1, code: 262 },
    {
      iso: "TG",
      name: intl.formatMessage("country.tg"),
      search: "TG Togolese",
      weight: 1,
      code: 228
    },
    {
      iso: "TH",
      name: intl.formatMessage("country.th"),
      search: "TH ประเทศไทย Prathet Thai",
      weight: 1,
      code: 66
    },
    {
      iso: "TJ",
      name: intl.formatMessage("country.tj"),
      search: "TJ Тоҷикистон Toçikiston",
      weight: 1,
      code: 992
    },
    { iso: "TK", name: intl.formatMessage("country.tk"), search: "TK", weight: 0.5, code: 690 },
    { iso: "TL", name: intl.formatMessage("country.tl"), search: "TL", weight: 1, code: 670 },
    {
      iso: "TM",
      name: intl.formatMessage("country.tm"),
      search: "TM Türkmenistan",
      weight: 1,
      code: 993
    },
    { iso: "TN", name: intl.formatMessage("country.tn"), search: "TN تونس", weight: 1, code: 216 },
    { iso: "TO", name: intl.formatMessage("country.to"), search: "TO", weight: 1, code: 676 },
    {
      iso: "TR",
      name: intl.formatMessage("country.tr"),
      search: "TR Türkiye Turkiye",
      weight: 1,
      code: 90
    },
    { iso: "TT", name: intl.formatMessage("country.tt"), search: "TT", weight: 1, code: 1868 },
    { iso: "TV", name: intl.formatMessage("country.tv"), search: "TV", weight: 0.5, code: 688 },
    {
      iso: "TW",
      name: intl.formatMessage("country.tw"),
      search: "TW 台灣 臺灣",
      weight: 1,
      code: 886
    },
    { iso: "TZ", name: intl.formatMessage("country.tz"), search: "TZ", weight: 1, code: 255 },
    {
      iso: "UA",
      name: intl.formatMessage("country.ua"),
      search: "UA Ukrayina Україна",
      weight: 1,
      code: 380
    },
    { iso: "UG", name: intl.formatMessage("country.ug"), search: "UG", weight: 1, code: 256 },
    { iso: "UM", name: intl.formatMessage("country.um"), search: "UM", weight: 1, code: 1 },
    {
      iso: "US",
      name: intl.formatMessage("country.us"),
      search: "US USA United States of America",
      weight: 3.5,
      code: 1
    },
    { iso: "UY", name: intl.formatMessage("country.uy"), search: "UY", weight: 1, code: 598 },
    {
      iso: "UZ",
      name: intl.formatMessage("country.uz"),
      search: "UZ Ўзбекистон O'zbekstan O‘zbekiston",
      weight: 1,
      code: 998
    },
    { iso: "VA", name: intl.formatMessage("country.va"), search: "VA", weight: 0.5, code: 39 },
    { iso: "VC", name: intl.formatMessage("country.vc"), search: "VC St.", weight: 1, code: 1784 },
    { iso: "VE", name: intl.formatMessage("country.ve"), search: "VE", weight: 1, code: 58 },
    { iso: "VG", name: intl.formatMessage("country.vg"), search: "VG", weight: 0.5, code: 1284 },
    { iso: "VI", name: intl.formatMessage("country.vi"), search: "VI", weight: 0.5, code: 1340 },
    {
      iso: "VN",
      name: intl.formatMessage("country.vn"),
      search: "VN Việt Nam",
      weight: 1.5,
      code: 84
    },
    { iso: "VU", name: intl.formatMessage("country.vu"), search: "VU", weight: 1, code: 678 },
    { iso: "WF", name: intl.formatMessage("country.wf"), search: "WF", weight: 0.5, code: 681 },
    { iso: "WS", name: intl.formatMessage("country.ws"), search: "WS", weight: 1, code: 685 },
    { iso: "YE", name: intl.formatMessage("country.ye"), search: "YE اليمن", weight: 1, code: 967 },
    { iso: "YT", name: intl.formatMessage("country.yt"), search: "YT", weight: 1, code: 262 },
    {
      iso: "ZA",
      name: intl.formatMessage("country.za"),
      search: "ZA RSA Suid-Afrika",
      weight: 1,
      code: 27
    },
    { iso: "ZM", name: intl.formatMessage("country.zm"), search: "ZM", weight: 1, code: 260 },
    { iso: "ZW", name: intl.formatMessage("country.zw"), search: "ZW", weight: 1, code: 263 }
  ];

  find(by: string): Array<Country> {
    if (by) {
      return this.countries
        .filter(
          (country) =>
            country.name.toLowerCase().includes(by.toLowerCase()) ||
            country.iso.toLowerCase().includes(by.toLowerCase()) ||
            country.search.toLowerCase().includes(by.toLowerCase()) ||
            ("+" + country.code).includes(by)
        )
        .sort((a, b) => b.weight - a.weight);
    } else {
      return this.countries;
    }
  }

  countryByIso(iso: string): Country | undefined {
    return this.countries.find((c) => c.iso === iso);
  }

  countryByName(name: string): Country | undefined {
    return this.countries.find((c) => c.name === name);
  }

  countryOfCode(code: any): Country | undefined {
    return this.countries.filter((country) => country.code === parseInt(code, 10))[0];
  }
}

export const countryService = lazy(() => new CountryService());
